import { Card, Container, Row, Col, Placeholder } from "react-bootstrap";
import { sysStatusToString } from "../../utils/define";
import "./style.css"

export type CompanyInfo = {
    infoKind: string
    companyName: string
    organization: string
    address: string
    phone: string
    agreement: {
        startDate: string
        endDate: string
    }
    staffName: string
    staffNameKana: string
    staffMail: string
    staffPhone: string
    sysStatus: string
    vehicleCount?: number
}

type CompanyInfoCardProp = {
    companyInfo: CompanyInfo
}

type CompanyInfoItemProp = {
    label: string
    value: string
}

const LabelPlaceholder = (props: {label: string}) => {
    return props.label === '' || props.label === '（）' || props.label === '~' ? (
        <Placeholder animation="wave">
            <Placeholder xs={6}  bg="bg-secondary" className="custom-bg">{' '}</Placeholder>
        </Placeholder>
    ) : (
        <>
            {props.label}
        </>
    )
}

const CompanyInfoItem = (props: CompanyInfoItemProp) => {
    return (
        <Container className="item">
            <Row className="item-label">
                {props.label}
            </Row>
            <Row className="item-value">
                <LabelPlaceholder label={props.value} />
            </Row>
        </Container>

    );
}

const CompanyInfoCard = (props: CompanyInfoCardProp) => {
    const vehicleCountValue = `${props.companyInfo.vehicleCount}件`;
    const vehicleCountLabel = props.companyInfo.sysStatus === '0' ? "車両数" : "在車台数";
    const vehicleCount = <CompanyInfoItem label={vehicleCountLabel} value={vehicleCountValue} />;
    return (
        <Card className="company-info-card">
            <Card.Header className="company-info-card header">{props.companyInfo.infoKind}</Card.Header>
            <Card.Body className="company-info-card body">
                <Container className="company-info-card section">
                    <Row>
                        <Col style={{borderRight:"dotted 1px #CCC6D1"}} md={6}>
                            <CompanyInfoItem label="会社名（組織ID）" value={`${props.companyInfo.companyName}（${props.companyInfo.organization}）`} />
                            <CompanyInfoItem label="住所" value={props.companyInfo.address} />
                            <CompanyInfoItem label="電話番号" value={props.companyInfo.phone} />
                            <CompanyInfoItem label="契約期間" value={`${props.companyInfo.agreement.startDate}~${props.companyInfo.agreement.endDate}`} />
                        </Col>
                        <Col md={6}>
                            <CompanyInfoItem label="担当者 氏名（フリガナ）" value={`${props.companyInfo.staffName}（${props.companyInfo.staffNameKana}）`} />
                            <CompanyInfoItem label="担当者 メールアドレス" value={props.companyInfo.staffMail} />
                            <CompanyInfoItem label="担当者 電話番号" value={props.companyInfo.staffPhone} />
                            <CompanyInfoItem label="システム種別" value={sysStatusToString(props.companyInfo.sysStatus)} />
                            {props.companyInfo.vehicleCount !== undefined ? vehicleCount : "" }
                        </Col>
                    </Row>
                </Container>
            </Card.Body>
        </Card>

    );
}

export default CompanyInfoCard;